module.exports = __webpack_public_path__ + "media/images/sites/health/bg-google-56867a2a37735d43e95164e3c13be314.jpg";